import InitPage from "../views/Static_Content/HomePage.vue";
import QuienesSomos from "../views/Static_Content/AboutUs.vue";
import ElProyecto from "../views/Static_Content/Project.vue";
import Contact from "../views/Static_Content/Contact.vue";

import Login from "../views/Login/Login.vue";
import LoginCreateAccount from "../views/Login/LoginCreateAccount.vue";
import LoginMessage from "../views/Login/LoginMessage.vue";
import LoginOrcidEmail from "../views/Login/LoginOrcidEmail";
import LoginUserProfile from "../views/Login/LoginUserProfile.vue";
import Loading from "../views/Loading/Loading.vue";
import ProjectCreate from "../views/Projects/ProjectCreate.vue";

import ProjectsList from "../views/Projects/ProjectsList.vue";
import ProjectDashboard from "../views/Projects/ProjectDashboard.vue";
import ProjectTopic from "../views/Projects/ProjectTopic.vue";
import ProjectTopicEdit from "../views/Projects/ProjectTopicEdit.vue";
import ProjectThreadTopic from "../views/Projects/ProjectThreadTopic.vue";
import ProjectDashboardParam from "../views/Projects/ProjectDashboardParam.vue";

import ContributorsList from "../views/ContributorsList.vue";

export default [
  {
    path: "/",
    name: "init",
    component: InitPage
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: QuienesSomos
  },
  {
    path: "/project",
    name: "project",
    component: ElProyecto
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/account",
    name: "account",
    component: LoginCreateAccount
  },
  {
    path: "/orcid",
    name: "message",
    component: LoginMessage,
    meta: {
      auth: false
    }
  },
  {
    path: "/orcidRegistration",
    name: "orcidRegistration",
    component: LoginOrcidEmail,
  },
  {
    path: "/user-profile",
    name: "profile",
    component: LoginUserProfile,
    meta: {
      auth: true
    }
  },
  {
    path: "/projectcreate",
    name: "projectcreate",
    component: ProjectCreate,
    meta: {
      auth: true
    }
  },
  {
    path: "/projects",
    name: "projects",
    component: ProjectsList
  },
  {
    path: "/dashboard/:project_id/:owner",
    name: "dashboard",
    component: ProjectDashboard
  },
  {
    path: "/dashboard/contributors/:project_id/:visibility",
    name: "contributors",
    component: ContributorsList
  },
  {
    path: "/newtopic/:project_id/:owner",
    name: "Comenzar nueva discusion",
    component: ProjectTopic
  },
  {
    path: "/edittopic/:project_id/:topic_id",
    name: "Editar discusion",
    component: ProjectTopicEdit
  },
  {
    path: "/threadtopic/:topic_id/:project_id",
    name: "Discusion",
    component: ProjectThreadTopic
  },
  {
    path: "/loading",
    name: "Loading",
    component: Loading
  },
  {
    path: "/dashboard/:project_id/:owner/topicsTab",
    name: "dashboardParam",
    component: ProjectDashboardParam
  }
];
